import "./YShortForm.scss";
import {
    ArrowRight,
    Code2,
    Globe,
    Laptop,
    Lightbulb,
    Rocket, Sparkles,
    Zap,
} from "lucide-react";
import SitePresentationWeb from "../../Components/SitePresentationWeb/SitePresentationWeb";
import logo from "../../Images/logo.png"
import {useTranslation} from "react-i18next";
import Card from "../../Components/CardGallery/CardGallery";
import {useNavigate} from "react-router-dom";
import {DiscordMember, GalleryItem, WorkItem} from "../../types";
import {discordUrl} from "../../Global";
import OurVideo from "../OurWorks/OurVideo/OurVideo";

const steps = [
    {
        id: "01",
        icon: Lightbulb,
    },
    {
        id: "02",
        icon: Laptop,
    },
    {
        id: "03",
        icon: Code2,
    },
    {
        id: "04",
        icon: Rocket,
    },
];

interface GMinecraftProps {
    staff: DiscordMember[] | [];
    workItems: WorkItem[];
}

export default function YShortForm({ staff, workItems }: GMinecraftProps) {
    const { t } = useTranslation();

    const roleIds = [
        '1425533293343932496',
        '1425533294061162507'
    ];

    const VYoutube = staff.filter((member) =>
        member.roles.some((role) => roleIds.includes(role.id))
    )

    const RandomTitle = Math.floor(Math.random() * 3) + 1

    return (
        <section className="graphics-minecraft">
            {/* ===== HERO ===== */}

            <div className="graphics-minecraft__hero">
                <div className="graphics-minecraft__hero-container">
                    {/* Left */}
                    <div className="graphics-minecraft__hero-content">
                        <h1 className="graphics-minecraft__title">
                            {t("youtube-short.title.up")}
                            <br />
                            {t("youtube-short.title.down")}<span>{t(`youtube-short.title.bold${RandomTitle}`)}</span>
                        </h1>
                        <p className="graphics-minecraft__description">
                            {t("youtube-short.subtitle")}
                        </p>
                        <div className="graphics-minecraft__actions">
                            <a href={discordUrl} target="_blank" className="graphics-minecraft__button" rel="noreferrer">
                                {t("youtube-short.preventive")}
                                <ArrowRight size={18} />
                            </a>
                        </div>
                    </div>

                    {/*Presentation*/}
                </div>
            </div>

            {/* ===== STEP ===== */}
            <div className="graphics-minecraft__steps">
                <div className="graphics-minecraft__steps-container">
                    <header className="graphics-minecraft__steps-header">
                        <h2>{t(`youtube-short.develop.title`)}</h2>
                        <p>{t(`youtube-short.develop.subtitle`)}</p>
                    </header>

                    <div className="graphics-minecraft__steps-grid">
                        {steps.map((step, index) => {
                            const Icon = step.icon;
                            return (
                                <div className="graphics-minecraft__step" key={step.id}>
                                    <div className="graphics-minecraft__step-icon">
                                        <Icon size={24} />
                                    </div>
                                    <h3 className="graphics-minecraft__step-title">{t(`youtube-short.develop.card.${step.id}.title`)}</h3>
                                    <p className="graphics-minecraft__step-description">{t(`youtube-short.develop.card.${step.id}.subtitle`)}</p>
                                    {index < steps.length - 1 && (
                                        <div className="graphics-minecraft__step-connector">
                                            <Zap size={14} />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* ===== TEAM ===== */}
            {VYoutube.length > 0 && (
                <div className="graphics-minecraft__team">
                <div className="graphics-minecraft__team-container">
                    <header className="graphics-minecraft__team-header">
                        <h2>{t(`youtube-short.employees.title`)}</h2>
                        <p>{t(`youtube-short.employees.subtitle`)}</p>
                    </header>

                    <div className="graphics-minecraft__team-grid">
                        {VYoutube.map((dev) => (
                            <a
                                key={dev.id}
                                target="_blank"
                                href={dev.avatar}
                                rel="noopener noreferrer"
                                className="graphics-minecraft__team-card"
                            >
                                <div className="graphics-minecraft__team-avatar">
                                    <img src={dev.avatar} alt={dev.username} />
                                    <div className={`graphics-minecraft__team-status graphics-minecraft__team-status_${dev.online}`} />
                                </div>
                                <h3>{dev.username}</h3>
                                <span>Video Maker</span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            )}

            {/* ===== PORTFOLIO ===== */}
            {workItems.length > 0 && (
                <div className="graphics-minecraft__portfolio" id="portfolio">
                    <div className="graphics-minecraft__portfolio-container">
                        <header className="graphics-minecraft__portfolio-header">
                            <h2>{t(`youtube-long.works.title`)}</h2>
                            <p>{t(`youtube-long.works.subtitle`)}</p>
                        </header>

                        <div className="video-short__portfolio-grid">
                            <OurVideo
                                title={false}
                                allWorkItems={workItems}
                            />
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}